import { useTimeout } from '@shared/hooks/useTimeout';
import { useState, useEffect, useRef } from 'react';

export const usePlaceholderCycler = (placeholder: string | string[], delay: number = 1000) => {
  const isArray = Array.isArray(placeholder);
  const [current, setCurrent] = useState(isArray ? placeholder[0] : placeholder);
  const indexRef = useRef(0);
  const { set: setTimeoutFn, clear: clearTimeoutFn } = useTimeout();

  useEffect(() => {
    if (!isArray) return;

    const cycle = () => {
      indexRef.current = (indexRef.current + 1) % placeholder.length;
      setCurrent(placeholder[indexRef.current]);
      setTimeoutFn(cycle, delay);
    };

    setTimeoutFn(cycle, delay);

    return () => clearTimeoutFn();
  }, [placeholder, isArray, delay, setTimeoutFn, clearTimeoutFn]);

  return current;
};
